import { useToast } from '@chakra-ui/react';
import { TYPES } from '../../index';
import useStore from '../zustand'
import { useDeleteFlow } from '../hooks/useDeleteFlow';
import useTracking from '../hooks/useTracking';
import trackingConsts from '../../config/tracking';

function useCreateFlowInteraction () {
  const toast = useToast();
  const { track } = useTracking();
  const { closeModal, setSelect } = useStore((store) => ({
    closeModal: store['modal/close'],
    setSelect: store.setSelect
  }))
  const { deleteFlow, error, isLoading } = useDeleteFlow()
  const flowDelete = async (id) => {
    try {
      const resp = await deleteFlow({id});
      toast({
        title: "Flow has been deleted.",
        status: "success",
        duration: 5000,
        position: 'top',
        isClosable: true,
      });
      track(trackingConsts.FLOWS.CONFIRMED_DELETE_FLOW, resp)
    } catch (e) {
      const description = e?.response?.data?.message || "Could not delete flow";
      toast({
        title: "Some error occurred",
        description,
        status: "error",
        duration: 5000,
        position: 'top',
        isClosable: true,
      });
      track(trackingConsts.FLOWS.CONFIRMED_DELETE_FLOW, {error: description})
    } finally {
      closeModal({type: TYPES.MODALS.DELETE_RECIPE});
      setSelect(TYPES.SELECT.RECIPE_RECORD, false);
    }
  }

  return { flowDelete, error, isLoading };
}

export default useCreateFlowInteraction
